module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.$emit("remove")
      }
    }
  }, [_vm._v(_vm._s(_vm.student.name)), _c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_vm._v(" (" + _vm._s(_vm.student.grade) + "점)")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-17c7212f"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/Student.vue
// module id = 327
// module chunks = 0